import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './reducers'

export const initializeStore = (
  preloadedState = {
    entities: {
      app: { name: `didn't get preloaded state` },
    },
  }
) => {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
  })
  return store
}
